
import React, { useEffect } from 'react';

const CancellationRefund = () => {
    return (
        <>
            <div className="container-fluid contact mt-3">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row">
                            <div className="col-md-12 mt-1">
                                {/* <Alert severity="info">
                                    {'TERMS STATEMENT'}<br />
                                    {'Datum: 09-DEC-2021'}
                                </Alert> */}
                            </div>
                            <div className="col-md-10 mt-5 fontStyle fontStyleTerms">
                                <h2>Cancellation and Refund Policy</h2>

                                <p>At Kaipsool Pharmatech, we understand that sometimes circumstances change, and you may need to cancel a service or request a refund. This policy outlines the procedures and conditions for cancellations and refunds.</p>
                                
                                <h5 className="mt-4 mb-3">Cancellation Policy:</h5>
                                <ol>
                                    <li>Cancellations by Users: Users can request cancellations for services as per cancellation policy provided by the event organizers. To cancel, please contact our support team or use the cancellation feature on the platform.</li>
                                    <li>Cancellations by Kaipsool Pharmatech: We reserve the right to cancel services due to unforeseen circumstances or non-compliance with our terms and conditions. In such cases, we will notify affected users as soon as possible.</li>
                                </ol>

                                <h5 className="mt-4 mb-3">Refund Policy:</h5>
                                <ol>
                                    <li>Eligibility for Refunds: Refunds will be considered in cases where a service was cancelled in accordance with our cancellation policy. If you believe you are eligible for a refund, please contact our support team.</li>
                                    <li>Refund Process: Refunds will be processed using the same method as the original payment or by a method of mutual agreement between Kaipsool Pharmatech team and the user . The time it takes for a refund to be credited to your account may vary depending on your payment provider.</li>
                                </ol>

                                <h5 className="mt-4 mb-3">Non-Refundable Services:</h5>
                                <ul>
                                    <li>Some services may be designated as non-refundable. Any such instances will be clearly stated when you book or purchase the service.</li>
                                </ul> 

                                <h5 className="mt-4 mb-3">Changes to Bookings:</h5>
                                <ul>
                                    <li>If you need to make changes to your appointment or booking, please contact our support team as soon as possible. We will do our best to accommodate your request, subject to availability.</li>
                                </ul>                          
                                <br /><br />
                                

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CancellationRefund
